class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.openDelay = 200;
    this.openDelaySwitch = 80;
    this.closeDelay = 200;

    this.panel = this.content?.querySelector('.mega-menu__list');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('focusin', this.onFocusIn.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this), true);

    if (this.panel) {
      this.panel.addEventListener('mouseleave', this.onPanelMouseLeave.bind(this));
    }
  }

  shouldKeepMenuOpen() {
    return (
      this.summary.matches(':hover') ||
      this.panel?.matches(':hover') ||
      this.content?.matches(':hover')
    );
  }

  scheduleClose() {
    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = window.setTimeout(() => {
      if (this.shouldKeepMenuOpen()) return;
      this.close();
    }, this.closeDelay);
  }

  onPanelMouseLeave(event) {
    if (!this.isHoverDesktop()) return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    const related = event.relatedTarget;
    if (related && (this.contains(related) || this.panel?.contains(related))) return;

    this.scheduleClose();
  }

  isDesktopLayout() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  isHoverDesktop() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  onMouseEnter() {
    if (!this.isHoverDesktop()) return;

    window.clearTimeout(this.closeTimeout);
    window.clearTimeout(this.openTimeout);

    const hasOpenSibling = Boolean(
      this.closest('.header__inline-menu')?.querySelector('header-menu > details[open]')
    );
    const delay = hasOpenSibling ? this.openDelaySwitch : this.openDelay;

    this.openTimeout = window.setTimeout(() => {
      if (!this.matches(':hover')) return;
      this.open();
    }, delay);
  }

  onMouseLeave() {
    if (!this.isHoverDesktop()) return;

    window.clearTimeout(this.openTimeout);
    this.scheduleClose();
  }

  onFocusIn() {
    if (!this.isDesktopLayout()) return;
    this.open();
  }

  onSummaryClick(event) {
    if (!this.isHoverDesktop()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.open();
  }

  open() {
    if (!this.isDesktopLayout()) return;

    window.clearTimeout(this.openTimeout);
    window.clearTimeout(this.closeTimeout);
    this.closeSiblingMenus();
    this.updateHeaderBottom();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.syncDesktopScrollLock();
  }

  updateHeaderBottom() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(headerWrapper.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    super.close();
    this.syncDesktopScrollLock();
  }

  closeSiblingMenus() {
    const menu = this.closest('.header__inline-menu');
    if (!menu) return;

    menu.querySelectorAll('header-menu').forEach((headerMenu) => {
      if (headerMenu !== this && typeof headerMenu.close === 'function') headerMenu.close();
    });
  }

  syncDesktopScrollLock() {
    const hasOpenDesktopMenu =
      this.isDesktopLayout() && document.querySelector('.header__inline-menu header-menu > details[open]');

    document.body.classList.toggle('header-menu-open', Boolean(hasOpenDesktopMenu));
  }

  onToggle() {
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;
    }

    this.updateHeaderBottom();
    this.syncDesktopScrollLock();
  }
}

customElements.define('header-menu', HeaderMenu);
